import Imatge, { hasImatge } from 'components/3catinfo/Imatge';
import Icona from 'components/3catinfo/ui/Icona';
import styles from './posterReel.module.scss';

const _showIconaPlay = () => {
    return (
        <div className={styles.icona_play} data-testid={`slide-icona-reproduir`}>
            <span className={styles.iconaWrapper}>
                <Icona
                    icona='play'
                    className={styles.play}
                    alt='reproduir'
                    isBlanc={true}
                    mida={112}
                    inline={true}
                    ariaHidden={true}
                />
            </span>
        </div>
    );
};

const PosterReel = (props) => {
    const { item, style, onClickElement } = props;
    const { id, titol, imatges } = item;
    const hasImatges = hasImatge(imatges, 'web_reels', null, null);

    const handleOnClick = () => {
        if (onClickElement) onClickElement(id);
    };

    return item ? (
        <div
            key={id}
            style={{ ...style }}
            className={styles.poster}
            role='button'
            aria-haspopup='dialog'
            aria-label={imatges?.alt || titol}
            onClick={handleOnClick}
            onKeyDown={(e) => {
                if (e.key === 'Enter') {
                    handleOnClick();
                }
            }}
            data-testid={`poster-reel-${id}`}
            tabIndex={0}
        >
            <div className={`${styles.wrapper}`}>
                <div className={styles.imatgeWrapper}>
                    {hasImatges && (
                        <Imatge
                            className={styles.imatge}
                            alt={imatges?.alt || titol}
                            imatges={imatges}
                            tipus='web_reels'
                            layout='fill'
                            objectFit='cover'
                        />
                    )}
                </div>
                {_showIconaPlay()}
            </div>
        </div>
    ) : (
        <></>
    );
};

export default PosterReel;
